import React, { PureComponent } from 'react';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import { Popover, Input } from 'antd';
import Modal from '../../components/Modal/';
import mathFormula from '../../constants/mathFormula';
import message from '../../components/Message';

import styles from './EditorModal.scss';

const { TextArea } = Input;

export default class EditorFormulaModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formula: this.props.initFormula || '',
      selection: {
        start: this.props.initFormula ? this.props.initFormula.length : 0,
        end: this.props.initFormula ? this.props.initFormula.length : 0,
      },
    };
  }

  componentDidMount() {
    document.addEventListener('selectionchange', this.changeSelection);
  }

  componentWillUnmount() {
    document.removeEventListener('selectionchange', this.changeSelection);
  }

  changeSelection = () => {
    const { textArea } = this.textArea.resizableTextArea;
    this.setState({
      selection: {
        start: textArea.selectionStart,
        end: textArea.selectionEnd,
      },
    });
  }

  formulaItem = () => {
    return Object.keys(mathFormula).map((item, index) => {
      return (
        <Popover
          key={index}
          trigger='click'
          content={this.formulaIcons(item, index)}
          className={styles['math-formula-modal-pop']}
          visible={this.state[`visible${index}`]}
          onVisibleChange={(visible) => { this.handleHoverChange(visible, index); }}
        >
          <li className={styles['math-formula-modal-item']}>
            {i18n.get(`modal.${item}`)}
            <i className={'fa fa-caret-up'}/>
          </li>
        </Popover>
      );
    });
  }

  formulaIcons = (item, index) => {
    return (
      <div className={classNames(styles['math-formula-modal-icon-content'], styles[`math-formula-modal-content-${index}`])}>
        {
          Object.keys(mathFormula[item]).map((icon, index2) => {
            return (
              <button
                onClick={() => this.insertFormula(icon, index)}
                dangerouslySetInnerHTML={{ __html: mathFormula[item][icon] }}
                key={index2}
              />
            );
          })
        }
      </div>
    );
  }

  handleHoverChange = (visible, index) => {
    this.setState({
      [`visible${index}`]: visible,
    });
    if (!visible) {
      const { textArea } = this.textArea.resizableTextArea;
      textArea.focus();
    }
  }

  insertFormula = (icon, index) => {
    const { selection, formula } = this.state;
    const { textArea } = this.textArea.resizableTextArea;
    const prevStart = selection.start;
    this.setState({
      [`visible${index}`]: false,
      formula: `${formula.slice(0, selection.start)}${icon}${formula.slice(selection.end)}`,
    }, () => {
      textArea.focus();
      textArea.selectionStart = prevStart + icon.length;
      textArea.selectionEnd = prevStart + icon.length;
    });
  }

  textChange = (e) => {
    this.setState({
      formula: e.target.value,
    });
  }

  onConfirmBtnClick = () => {
    const { onModalConfirmBtnClick } = this.props;
    const { formula } = this.state;
    if (!formula) {
      message.warning(i18n.get('modal.insert-empty'));
      return false;
    }
    onModalConfirmBtnClick('formulaModal', { formula });
    return 0;
  }

  render() {
    const { onModalCancelClick } = this.props;
    const { formula } = this.state;
    return (
      <Modal
        width={500}
        visible
        showFooter
        maskClosable={false}
        showMask
        closable
        isMiddle
        onCancel={onModalCancelClick}
        onOk={this.onConfirmBtnClick}
      >
        <div className={styles['math-formula-modal']}>
          <h3 className={styles['math-formula-modal-title']}>{i18n.get('modal.insert-math-formula')}</h3>
          <div className={styles['math-formula-modal-content']}>
            <ul className={styles['math-formula-modal-list']}>
              {
                this.formulaItem()
              }
            </ul>
            <TextArea
              className={styles['math-formula-modal-text']}
              onChange={this.textChange}
              value={formula}
              ref={(x) => { this.textArea = x; }}
            />
          </div>
          <div className={styles['math-formula-modal-render']}>
            <img src={`https://math.jianshu.com/math?formula=${encodeURIComponent(formula)}`} alt={formula}/>
          </div>
          <a
            href='https://en.wikibooks.org/wiki/LaTeX/Mathematics'
            rel="noopener noreferrer"
            target="_blank"
            className={styles['math-formula-modal-link']}
          >
            <i className="fa fa-question-circle"/>
            {i18n.get('modal.math-formula-grammar')}
          </a>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorFormulaModal.js